(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconic-branding-text"] && !Shopify.designMode) return;
  try {
    
  function adjustFontSizeToFill(containerId, textId) {
    const container = document.getElementById(containerId);
    const text = document.getElementById(textId);
    if (!text) return;
  
    function adjustFontSize() {
      const targetPercentage = window.innerWidth <= 767
      ? parseFloat(text.getAttribute('data-font-size-mobile')) || 100
      : parseFloat(text.getAttribute('data-font-size')) || 100;
      
      let fontSize = 10;
      let increment = 1;
      let maxWidth = container.offsetWidth * (targetPercentage / 100);
      text.style.whiteSpace = 'nowrap';
      text.style.fontSize = `${fontSize}px`;
  
      while (text.offsetWidth < maxWidth && fontSize < 300) {
        fontSize += increment;
        text.style.fontSize = `${fontSize}px`;
      }
  
      if (text.offsetWidth > maxWidth) {
        fontSize -= increment;
        text.style.fontSize = `${fontSize}px`;
      }
      text.classList.add('adjusted');
    }
  
    setTimeout(() => {
      adjustFontSize();
    }, 250);
  
    window.addEventListener('resize', adjustFontSize);
  }
  
  function applyFontAdjustments() {
    const brandingSections = document.querySelectorAll('.iconic-branding-text-section');
    
    brandingSections.forEach((section) => {
      const sectionId = section.getAttribute('data-section-id');
      const containerId = `brandingWrapper-${sectionId}`;
      const textId = `brandingText-${sectionId}`;
      adjustFontSizeToFill(containerId, textId);
    });
  }
  window.addEventListener('load', applyFontAdjustments);
  document.addEventListener('DOMContentLoaded', applyFontAdjustments);
  
  document.addEventListener('shopify:section:load', function () {
    applyFontAdjustments();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconic-card-list-first"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('.iconic-card-list-wrap');

    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        const overlay = card.querySelector('.iconic-overlay-text');
        if (overlay && overlay.firstElementChild) {
          const child = overlay.firstElementChild;
          const childHeight = child.offsetHeight;
          const hoverCard = card.querySelector('.iconic-image-hover-card');
          if (hoverCard) {
            hoverCard.style.setProperty('--child-height', `${childHeight}px`);
          }
        }
      });
    });
  });
  

  } catch(e) { console.error(e); }
})();
})();
